import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function TrialBanner() {
  const { user } = useAuth();
  const b = user?.billing;
  if (!b || b.plan !== "trial" || !b.is_active) return null;
  const days = b.days_left ?? 0;
  return (
    <div
      data-testid="trial-banner"
      className="flex items-center justify-between gap-3 px-4 py-2 bg-amber-500/10 border-b border-amber-500/30 text-xs"
    >
      <div className="flex items-center gap-2 text-amber-200">
        <Sparkles size={14} />
        <span>
          You're on the free trial — <strong>{days} day{days === 1 ? "" : "s"}</strong> left.
        </span>
      </div>
      <Link
        to="/billing"
        className="text-amber-300 hover:text-amber-100 font-semibold whitespace-nowrap"
        data-testid="trial-banner-upgrade-link"
      >
        Choose a plan →
      </Link>
    </div>
  );
}
